import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ClientProfileView } from "@/components/care/ClientProfileView";
import { ClientEditorDialog } from "@/components/care/ClientEditorDialog";

export default function ClientProfilePage() {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [editing, setEditing] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <>
      <ClientProfileView clientId={clientId} onBack={() => navigate("/admin/clients")} onEdit={setEditing} refreshKey={refreshKey} />
      {editing && <ClientEditorDialog initial={editing} onClose={() => setEditing(null)} onSaved={() => setRefreshKey((k) => k + 1)} />}
    </>
  );
}
